/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S6_P1Inputs */

const en_guide_what_is_json_s6_p1 = /** @type {(inputs: Guide_What_Is_Json_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow these guidelines to write clean, maintainable JSON:`)
};

const ko_guide_what_is_json_s6_p1 = /** @type {(inputs: Guide_What_Is_Json_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`깔끔하고 유지보수 가능한 JSON을 작성하려면 다음 가이드라인을 따르세요:`)
};

const ja_guide_what_is_json_s6_p1 = /** @type {(inputs: Guide_What_Is_Json_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリーンで保守しやすいJSONを書くためのガイドラインです：`)
};

/**
* | output |
* | --- |
* | "Follow these guidelines to write clean, maintainable JSON:" |
*
* @param {Guide_What_Is_Json_S6_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s6_p1 = /** @type {((inputs?: Guide_What_Is_Json_S6_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S6_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s6_p1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s6_p1(inputs)
	return ja_guide_what_is_json_s6_p1(inputs)
});